import styled from "styled-components";
import {logo_inline_w} from "../../constants/GlobalConst";

export const SignUpHeader = styled.header`
  display: flex;
  height: 72px;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 15% 20%, rgba(255,255,255,.14) 0 45px, transparent 46px),
    radial-gradient(circle at 82% 78%, rgba(255,255,255,.1) 0 150px, transparent 151px),
    linear-gradient(rgb(32, 36, 43) 0%, rgb(25, 28, 34) 100%);
  box-shadow: 0 3px 12px rgba(96, 54, 20, .12);
`;

export const Logo = styled.div`
  width: 174px;
  height: 42px;
  background-image: url(${logo_inline_w});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

export const BodyContainer = styled.main`
  min-height: calc(100vh - 72px);
  box-sizing: border-box;
  padding: 28px 24px 48px;
  background: #f5f6f8;

  @media (max-width: 640px) {
    padding: 22px 12px 36px;
  }
`;

export const StepContainer = styled.section`
  width: min(100%, 1080px);
  margin: 0 auto 18px;

  & > article {
    padding: 0;
  }

  & article > div h1 {
    margin: 0;
    color: #20242b;
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -.03em;
    text-align: center;
  }

  & article > div > p {
    margin: 7px 0 0;
    color: #7b838c;
    font-size: 13px;
    line-height: 1.5;
    text-align: center;
  }
`;

export const Steps = styled.div`
  display: grid;
  grid-template-columns: 1fr 22px 1fr 22px 1fr;
  align-items: center;
  gap: 8px;
  margin: 24px 0 0;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const Step = styled.div`
  display: flex;
  min-width: 0;
  min-height: 66px;
  box-sizing: border-box;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 1px solid ${({$active}) => $active ? "#f1c49f" : "#e3e6e9"};
  border-radius: 10px;
  background: ${({$active}) => $active ? "#fff7ef" : "#fff"};
  box-shadow: ${({$active}) => $active ? "0 5px 14px rgba(245,129,31,.08)" : "none"};

  & > div:first-child {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    border-radius: 50%;
    background-color: ${({$active}) => $active ? "#f5811f" : "#f1f3f4"};
    background-repeat: no-repeat;
    background-position: center;
    background-size: 36px;
  }

  & > div:last-child {
    min-width: 0;
  }

  & > div:last-child h3 {
    margin: 0 0 4px;
    color: ${({$active}) => $active ? "#e87518" : "#a1a7ad"};
    font-size: 11px;
    font-weight: 800;
    letter-spacing: .08em;
  }

  & > div:last-child p {
    margin: 0;
    color: ${({$active}) => $active ? "#343b42" : "#8c939a"};
    font-size: 13px;
    font-weight: 700;
    text-align: left;
  }
`;

export const Arrow = styled.div`
  width: 22px;
  height: 22px;
  background-image: url("/assets/images/join/icon_next.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px auto;
  opacity: .45;

  @media (max-width: 720px) {
    display: none;
  }
`;

export const SignUpContents = styled.section`
  width: min(100%, 1080px);
  box-sizing: border-box;
  margin: 0 auto;
  padding: 26px 28px 30px;
  border: 1px solid #e5e8eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(31, 41, 55, .06);

  .done {
    display: flex;
    min-height: 390px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  & article h2 {
    margin: 0 0 10px;
    color: #252b31;
    font-size: 18px;
    font-weight: 800;
  }

  & article h3 {
    margin: 22px 0 9px;
    color: #41484f;
    font-size: 14px;
  }

  @media (max-width: 640px) {
    padding: 22px 16px 26px;
  }
`;

export const TermsBox = styled.div`
  width: 100%;
  height: 190px;
  box-sizing: border-box;
  overflow: auto;
  padding: 16px;
  border: 1px solid #e2e5e8;
  border-radius: 8px;
  background: #fff;
  color: #606870;
  font-size: 12px;
  line-height: 1.65;
`;

export const AlignRight = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 14px 0;
  color: #606870;
  font-size: 12px;
`;

export const VerticalRule = styled.div`
  width: 100%;
  height: 1px !important;
  background-color: #edf0f2 !important;
`;

export const ButtonGroup = styled.div`
  position: ${({$sticky}) => $sticky ? "sticky" : "relative"};
  bottom: ${({$sticky}) => $sticky ? "12px" : "auto"};
  z-index: ${({$sticky}) => $sticky ? "20" : "auto"};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 9px;
  box-sizing: border-box;
  margin-top: 22px;
  padding: 16px 20px;
  border: 1px solid #ffd7b5;
  border-left: 4px solid #f5811f;
  border-radius: 10px;
  background: linear-gradient(90deg, #fff8f2 0%, rgba(255, 255, 255, .98) 48%);
  box-shadow: 0 -4px 20px rgba(245, 129, 31, .09);

  & button {
    min-width: 112px;
    height: 40px;
    box-sizing: border-box;
    padding: 0 18px;
    border-radius: 7px;
    font-family: inherit;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
    transition: background-color .15s ease, border-color .15s ease;
  }

  & button:first-child {
    border: 1px solid #dfe3e7;
    background: #fff;
    color: #666e76;
  }

  & button:first-child:hover {
    border-color: #f1b98d;
    color: #e87518;
  }

  & button:last-child {
    margin-left: 0;
    border: 1px solid #f5811f;
    background: #f5811f;
    color: #fff;
    box-shadow: 0 5px 12px rgba(245,129,31,.18);
  }

  & button:last-child:hover {
    background: #df7017;
  }

  @media (max-width: 520px) {
    align-items: stretch;
    flex-direction: column-reverse;
    padding: 14px;

    & button {
      width: 100%;
    }
  }
`;

export const Form = styled.div`
  display: grid;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 16px;
  margin: 16px 0 0;
  padding: 0;
  border: 0;
  background: #fff;

  @media (max-width: 940px) {
    grid-template-columns: 1fr;
  }
`;

export const FormSection = styled.section`
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(31, 41, 55, .04);
`;

export const FormSectionHeader = styled.header`
  display: flex;
  min-height: 68px;
  box-sizing: border-box;
  align-items: center;
  padding: 15px 18px;
  border-bottom: 1px solid #eceff1;
  background: #fafbfc;
`;

export const FormSectionTitle = styled.h3`
  margin: 0 !important;
  color: #2d343b !important;
  font-size: 15px !important;
  font-weight: 800;
`;

export const FormSectionDescription = styled.p`
  margin: 5px 0 0;
  color: #858d95;
  font-size: 12px;
  line-height: 1.45;
`;

export const FormSectionBody = styled.div`
  padding: 5px 18px 10px;

  & > div {
    position: relative;
    display: grid;
    min-height: 58px;
    box-sizing: border-box;
    grid-template-columns: 150px minmax(0, 1fr);
    align-items: center;
    gap: 14px;
    margin: 0;
    padding: 9px 0;
    border-bottom: 1px solid #f0f2f4;
    color: #444c54;
    font-size: 13px;
  }

  & > div:last-child {
    border-bottom: 0;
  }

  & > div > div:first-child {
    width: auto;
    font-weight: 700;
  }

  & > div > div:last-child {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 8px;
  }

  & > div > div:last-child > * {
    margin-right: 0;
  }

  input[type='text'],
  input[type='password'],
  select {
    width: min(100%, 620px);
    min-width: 0 !important;
    height: 40px;
    box-sizing: border-box;
    padding: 0 12px;
    border: 1px solid #dfe3e7;
    border-radius: 7px;
    background: #fff;
    color: #30363d;
    font-family: inherit;
    font-size: 13px;
    outline: 0;
  }

  input:focus,
  select:focus {
    border-color: #f5811f;
    box-shadow: 0 0 0 3px rgba(245,129,31,.08);
  }

  input[readonly] {
    background: #f4f6f7;
    color: #747c84;
  }

  input[type='radio'] {
    accent-color: #f5811f;
  }

  label {
    color: #555d65;
    font-size: 13px;
  }

  @media (max-width: 720px) {
    & > div {
      grid-template-columns: 1fr;
      gap: 7px;
    }

    & > div > div:last-child {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 640px) {
    padding-right: 14px;
    padding-left: 14px;
  }
`;

export const SignUpVerify = styled.button`
  min-width: 124px !important;
  height: 40px !important;
`;

export const AfterSignUpGuild = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  & .tit {
    margin: 22px 0 8px;
    color: #292f35;
    font-size: 20px;
    font-weight: 800;
  }

  & .txt {
    color: #7f878f;
    font-size: 13px;
  }
`;

export const Round = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px solid #f1d4c2;
  border-radius: 50%;
  background-color: #fff8f2;
  background-image: url("/assets/images/join/img_number_03.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 92px;
`;

export const ValidationScript = styled.div`
  position: absolute;
  bottom: -4px;
  left: 164px;
  color: #d84f4f;
  font-size: 11px !important;

  @media (max-width: 720px) {
    position: static;
    width: 100%;
  }
`;

export const DuplicateButton = styled.button`
  min-width: 92px;
  height: 38px;
  flex: 0 0 auto;
  padding: 0 13px;
  border: 1px solid #f1c8a7;
  border-radius: 6px;
  background: #fff7ef;
  color: #e87518;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
`;
